export default __webpack_public_path__ + "static/media/promos-icon.eba815c0.webp";